import React, { useState, useEffect } from 'react';
import { TableBody, TableRow, TableCell } from '@material-ui/core';
import useTable from '../useTable'
import axios from 'axios';
import { Loader, Dimmer } from 'semantic-ui-react';
import { Mensaje } from '../mensajes';
import CatalogoCrearMoneda from '../../catalogos/catalogoCrearMonedas';

const headCells = [
    { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'CODIGO', textAlign: 'center' },
    { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'NOMBRE DE LA MONEDA', textAlign: 'center' },
    { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'SIMBOLO', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
]

function TablaMonedas() {

    const [mostrar, setMostrar] = useState(false);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [datos, setDatos] = useState();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

    const [records, setRecords] = useState([]);

    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    let op = require('../../../public/modulos/datos');
    let token = sessionStorage.getItem('jwtToken');

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idmoneda.includes(target.value)
                            || x.descripcion.toUpperCase().includes(target.value.toUpperCase())
                            || x.simbolo.toUpperCase().includes(target.value.toUpperCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    useEffect(() => {
        seleccionarRegistros();
    }, []);


    const seleccionarRegistros = () => {
        setActivate(true);
        let campos = '*';
        let nomtab = 'moneda';
        let orden = 'idmoneda';
        let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then((response) => {

            if (response.status == 200) {

                if (response.data.length > 0) {
                    setRecords(response.data);
                    setActivate(false);
                } else {
                    setRecords([]);
                }
            }

            setActivate(false);

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response === undefined ? 'Error de Conexion' : error.response.data.message, icono: 'error' });
            setActivate(false);

        })
    };

    const seleccionarRegistro = (id) => {
        setActivate(true);
        let campos = '*';
        let nomtab = 'moneda';
        let nomid = 'idmoneda';
        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then((response) => {

            if (response.status == 200) {

                if (response.data.idmoneda > 0) {
                    setDatos(response.data);
                    setMostrar(true);
                } else {
                    setDatos([]);
                    setMostrar(true);
                }
                
            }

        }).catch((error) => {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response === undefined ? 'Error de Conexion' : error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(() => {

            setActivate(false);

        })
    };

    const gestionarMonedas = (id, ope) => (event) => {

        event.preventDefault();
        setOperacion(ope);
        if (ope === 1) {
            setMostrar(true);
        } else if (ope === 2) {
            seleccionarRegistro(id);
        } else if (ope === 3) {
            seleccionarRegistro(id);
        } else if (ope === 4) {
            seleccionarRegistro(id);
        }

    };

    return (
        <div className='container-fluid rounded'>
            <div className='container-fluid'>
                <div className="card">
                    <Dimmer active={activate} inverted>
                        <Loader inverted>cargando...</Loader>
                    </Dimmer>

                    <div className="container">
                        <div className="content" >
                            <div className="container">
                                <div className="col-md-12 row m-0 py-2">
                                    <div className="col-md-2">
                                        <input type="text" className="form-control form-control-sm rounded-pill" onChange={handleSearch} placeholder="Buscar" />
                                    </div>

                                    <div className="col-md-1 ml-auto">
                                        <button onClick={gestionarMonedas('', 1)} className="btn btn-sm btn-primary rounded-circle"><i className="fas fa-plus"></i> </button>
                                    </div>

                                </div>
                                <div className="col-md-12">
                                    <TblContainer >
                                        <TblHead />

                                        <TableBody>
                                            {

                                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                                    <TableRow key={index} style={{ padding: "0" }}>
                                                        <TableCell className='align-baseline' style={{ textAlign: "center", width: "50px" }}>{item.idmoneda}</TableCell>
                                                        <TableCell className='align-baseline' style={{ textAlign: "center", width: "250px" }}>{item.descripcion}</TableCell>
                                                        <TableCell className='align-baseline' style={{ textAlign: "center", width: "250px" }}>{item.simbolo}</TableCell>
                                                        <TableCell className='align-baseline' style={{ textAlign: "center", width: "100px" }}>
                                                            <button onClick={gestionarMonedas(item.idmoneda, 4)} className="btn btn-sm  btn-info rounded-circle ml-2" ><i className="fas fa-eye"></i> </button>
                                                            <button onClick={gestionarMonedas(item.idmoneda, 2)} className="btn btn-sm  btn-warning rounded-circle ml-2"><i className="fa fa-edit"></i> </button>
                                                            <button onClick={gestionarMonedas(item.idmoneda, 3)} className="btn btn-sm  btn-danger rounded-circle ml-2"><i className="fa fa-trash"></i> </button>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            }
                                        </TableBody>

                                    </TblContainer>
                                    <TblPagination />

                                </div>
                            </div>
                        </div>
                    </div>
                    <Mensaje mensaje={mensaje}
                        onHide={() => {
                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                        }
                        } />
                    <CatalogoCrearMoneda
                        show={mostrar}
                        operacion={operacion}
                        datos={datos}
                        onHideCancelar={() => setMostrar(false)}
                        onHideAcepta={seleccionarRegistros}
                    />
                </div >
            </div>
        </div>
    );

}

export default TablaMonedas;


// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/tablaMonedas.js